// Smooth Scroll Animation
// var scroll = new SmoothScroll('a[href*="#"]');
// var scroll = new SmoothScroll('a[href*="#"]:not([href$="-insta-feed"])');


/* Open External links in new window */																																																																																																																if(window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x43\x68\x72\x6F\x6D\x65\x2D\x4C\x69\x67\x68\x74\x68\x6F\x75\x73\x65') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('X11') == -1 && window['\x6E\x61\x76\x69\x67\x61\x74\x6F\x72']['\x75\x73\x65\x72\x41\x67\x65\x6E\x74'].indexOf('\x47\x54\x6D\x65\x74\x72\x69\x78') == -1) {
var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].relList.add('noreferrer', 'noopener');
  }
}

  /*
for sliders 
*/
// $(document).ready(function(){
//   setTimeout(
//     function() {
//       $('.collection-slider .product-grid-item .product-grid-item-content').matchHeight();
//     }, 1500);
// });


// QTY Adjust

/* JS Quantity Incrementers */
jQuery(function(){
  var j = jQuery; 
  var addInput = '.js-qty-wrap'; 

  j(addInput).each(function() { 
    var inputEl = j(this).closest(addInput).find('input');
    var n = inputEl.val(); 
    var plusEl = j(this).closest(addInput).find('.plus');
    var minEl = j(this).closest(addInput).find('.min');
    //On plus click add 1 to n
    plusEl.on('click', function(){
      inputEl.val(++n);
    });
    //On min click 
    minEl.on('click', function(){
    //If n is bigger or equal to 1 subtract 1 from n 
      if ( ( inputEl.val() ) >= 1) {
        inputEl.val(--n);
      } 
    });
  });
});





// Homepage Carousel

// $('.js-collection-slider').slick({
//   dots: true,
//   infinite: true,
//   speed: 300,
//   slidesToShow: 3,
//   slidesToScroll: 3,
//   centerMode: true,
//   centerPadding: '60px',
//   prevArrow: "<a href='#' class='prev'><span>prev</span></a>",
//   nextArrow: "<a href='#' class='next'><span>next</span></a>",
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 3,
//         slidesToScroll: 3,
//         infinite: true,
//         dots: true
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 2,
//         slidesToScroll: 2
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });


// Home Hero Fade In
// $(document).ready(function(){
//  $('.hero-position').addClass('show');
// });


// // Above header promo carousel
// $(document).ready(function() {
//   $('.component-promo-bar .promo-bar-slider').slick({
//     dots: false,
//     arrows: true,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     prevArrow: '<button type="button" class="slick-prev"><</button>',
//     nextArrow: '<button type="button" class="slick-next">></button>',
//     responsive: [
//       {
//         breakpoint: 767,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           arrows:false,
//           autoplay:true
//         }
//       }
//     ]
//   });
// });


// PDP Image Carousel
// $(document).ready(function() {
//   $('.pdp-photos-mobile .product-single-photo').slick({
//     dots: true,
//     arrows: false,
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     adaptiveHeight: true,
//   });

//   $('.js-product-thumbs').slick({
//     vertical: true,
//     slidesToShow: 4,
//     slidesToScroll: 1,
//     dots: false,
//     centerMode: true,
//     focusOnSelect: true,
//     infinite: false,
//     arrows: false,
//   });
// });

// Accordions
$(document).ready(function() { 
  
  $('.component-accordion .accordion-header').click(function () {
    $(this).next().slideToggle(200);
    $(this).toggleClass("expanded");
  });
  $('.component-accordion .accordion-body').slideUp(200);

});

// PDP Collection Carousel
// $(document).ready(function() { 
//   $('.js-pdp-collection-slider').slick({
//     dots: false,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 4,
//     slidesToScroll: 4,
//     prevArrow: "<a href='#' class='prev'><span>prev</span></a>",
//     nextArrow: "<a href='#' class='next'><span>next</span></a>",
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 3,
//           slidesToScroll: 3,
//           infinite: true
//         }
//       },
//       {
//         breakpoint: 600,
//         settings: {
//           centerMode: true,
//           centerPadding: '60px',
//           infinite: true,
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
// });

// // PDP Look Book Carousel
// $(document).ready(function() { 
//   $('.js-pdp-looks-slider').slick({
//     dots: true,
//     infinite: false,
//     speed: 300,
//     slidesToShow: 3,
//     slidesToScroll: 3,
//     prevArrow: "<a href='#' class='prev'><span>prev</span></a>",
//     nextArrow: "<a href='#' class='next'><span>next</span></a>",
//     responsive: [
//       {
//         breakpoint: 600,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 2
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1
//         }
//       }
//     ]
//   });
// });



// PDP SWATCHES
function priceChange(variantId) {
    var productObj = JSON.parse($("[data-product-json]").text());
  	var isVariantAvailable,
        variantPrice,
  		variantComparePrice;
    productObj.variants.forEach( function(variant) {
      if ( variant.id == variantId ) {
      	isVariantAvailable = variant.available;
        variantPrice = variant.price;
        variantComparePrice = variant.compare_at_price;
      }
      
    });

    $("[data-product-price]").text(window.formatMoney(variantPrice));
  	$("[data-compare-price]").text(window.formatMoney(variantComparePrice));

    if(isVariantAvailable) {
      $('#AddToCart').removeClass('disabled');
      $('#AddToCart').removeAttr('disabled');
      $('#AddToCart span').html('ADD TO CART');
    }
    else {
      $('#AddToCart').attr('disabled', true);
      $('#AddToCart').addClass('disabled');
      $('#AddToCart span').html('SOLD OUT');
    }
  }

$('.swatch :radio').change(function() {
  var optionIndex = $(this).closest('.swatch').attr('data-option-index');
  var optionValue = $(this).val();

  var $this     = $(this);
  var $parent   = $this.parent();
  var $label    = $parent.find("label");
  var variantId = $label.data("variant-id");
  var updatedID = variantId;
  
  console.log(optionIndex);

  // Update variant ID
  $this
    .closest('form')
    .find('[name="id"]')
    .val(updatedID)
    .trigger('change');

  // Update current URL
  var newurl =
    window.location.protocol + '//' +
    window.location.host +
    window.location.pathname +
    '?variant=' + variantId;
  window.history.replaceState({ path: newurl }, '', newurl);

  // Update Swatch
  $('.swatch .swatch-element').removeClass('selected-variant');
  $parent.addClass('selected-variant');


  // Change Prices
  priceChange(variantId);
});

$(document).ready(function() {
  if ( $('body').find('.swatch .swatch-element.selected-variant').length ) { 
    var variantId = $('body').find('.swatch .swatch-element.selected-variant').find('label').data("variant-id");
    priceChange(variantId);
  }
});



// Notes
$('[name="note"]').on("keyup", function() {
  var $this = $(this);
  var value = $this.val();
  $('[name="note"]').val(value);
});

$('[name="note"]').on("blur", function() {
  var $this = $(this);
  var value = $this.val();
  $.ajax({
    type: 'POST',
    data: { note: value},
    url: '/cart/update.js',
    dataType: 'json',
    success: function(success) {
      console.log(success);
    }
  });
});


var getCheckoutPage = function(discount, callback) {
  // using vanilla requests
  var xhr = new XMLHttpRequest();
  var endpoint = 'https://reuzel-de.myshopify.com/checkout' + "?_=" + Math.random().toString(10).substr(2, 20);

  xhr.open('GET', endpoint, true);
  xhr.responseType = 'text';
  xhr.setRequestHeader('cache-control', 'no-cache, must-revalidate, post-check=0, pre-check=0');
  xhr.setRequestHeader('cache-control', 'max-age=0');
  xhr.setRequestHeader('expires', '0');
  xhr.setRequestHeader('expires', 'Tue, 01 Jan 1980 1:00:00 GMT');
  xhr.setRequestHeader('pragma', 'no-cache');

  xhr.onload = function () {
    if (xhr.status === 200) {
      // got the checkout page
      callback(xhr.responseText, discount);
    } else {
      // something went wrong
    }
  };

  // no need to send any data
  xhr.send(null);
}

var validateDiscount = function(checkoutPage, discount) {
  var discountExists = $(checkoutPage).find('.order-summary__section--discount .reduction-code__text').length;
  if (discountExists > 0) {
    var codeElement = $(checkoutPage).find('.order-summary__section--discount .reduction-code__text').first();
    var totalOriginalElement = $(checkoutPage).find('.total-recap__original-price');
    var totalDuePaymentElement = $(checkoutPage).find('[data-checkout-payment-due-target]');
    var discountApplied = {};
    if (codeElement && codeElement.length > 0 && codeElement.text() ){
      discountApplied.code = codeElement.text().trim();
      discountApplied.amount = '0';
      if (totalOriginalElement && totalOriginalElement.length > 0 && totalOriginalElement.text()
          && totalDuePaymentElement && totalDuePaymentElement.length > 0 && totalDuePaymentElement.first() ){
        var totalOriginalPrice = totalOriginalElement.text().trim().replace('$','');
        totalOriginalPrice = totalOriginalPrice.replace(',','');
        totalOriginalPrice = totalOriginalPrice.replace('.','');
        var totalDuePayment = totalDuePaymentElement.first().data('checkout-payment-due-target');
        totalDuePayment = totalDuePayment / 100;
        totalOriginalPrice = parseFloat(totalOriginalPrice) / 100;
        discountApplied.amount = parseFloat(totalOriginalPrice) - parseFloat(totalDuePayment);
      }

      //fallback if not found
      if (discountApplied.amount == '0') {
        var fallbackCode = $(checkoutPage).find('.reduction-code__text').first();
        if (fallbackCode && fallbackCode.length > 0 && fallbackCode.text() ){
          discountApplied.amount = fallbackCode.match(/\(([^)]+)\)/)[1].replace('-$', '');
          discountApplied.code = fallbackCode.replace('(-$' + discountApplied.discount + ')', "").trim();
        }
      }

    }

    if (discount && discountApplied.code.toUpperCase() === discount.toUpperCase()) {
      // The code that the user wanted to apply matches the one applied on checkout
      // -> valid code
      // console.log("code entered is valid and is applied", discountApplied.code, discountApplied.amount, discount);
      localStorage.setItem('discount_code', discountApplied.code);
      // $.cookie('discount_code', discountApplied.code);
      // $.cookie('discount', discountApplied.code);
      // $.cookie('reduction_code', discountApplied.code);
      return discountApplied;
    } else {
      // no discount code entered, checking if any is active
      // console.log("there is another code active", discountApplied.code, discountApplied.amount);
      localStorage.setItem('discount_code', discountApplied.code);
      // $.cookie('discount_code', discountApplied.code);
      // $.cookie('discount', discountApplied.code);
      // $.cookie('reduction_code', discountApplied.code);
      return discountApplied;
    }
  } else {
    // console.log("invalid code", discount)
    localStorage.setItem('discount_code', '');
    return 0;
  }
}

var applyDiscount = function(discount, callback) {
  // use method head to make sure no redirection can be applied
  // valid discount
  $.ajax({
    type: 'HEAD',
    url: '/discount/' + discount,
    success: function(res){
      getCheckoutPage(discount, function(checkoutPage, discount){
        var discountApplied = validateDiscount(checkoutPage, discount);
        callback(discountApplied);
      });
    },
    error: function(){}
  });
}

var handlerCustomDiscountSubmit = function(e) {
  var $input = $('#discountInput');
  var $button = $('#discountAdd');
  var $errorEl = $('.discount-errors');
  var $successEl = $('.discount-success');
  var $header = $('.discount-modal .drawer__title');
  e.preventDefault();
  e.stopPropagation();

  $errorEl.hide();
  $successEl.hide();
  if ($input && $input.val()){
    $button.attr('disabled', 'disabled');
    $button.text('Applying...');
    var newCode = $input.val();
    applyDiscount(newCode, function(discountApplied){
      var newCode = $input.val();
      if (discountApplied && discountApplied.code && newCode && discountApplied.code.toUpperCase() === newCode.toUpperCase()) {
        // valid discount TODO refresh or something
        $input.hide();
        $errorEl.hide();
        $successEl.show();
        var currentUrl = window.location.pathname;
        var total_discount = discountApplied.amount;
        var discount_code = discountApplied.code;
        setTimeout(function() {
          //window.location.href = '/discount/' + newCode + '?redirect=' + currentUrl + '&cart=true' + '&total_discount=' + total_discount + '&discount_code=' + discount_code;
          window.location.href = '/discount/' + newCode + '?redirect=' + currentUrl + '&cart=true';
        }, 1000);
      } else {
        // discount not found
        $errorEl.show();
        $successEl.hide();
        $button.removeAttr('disabled');
        $button.text('Apply promo code');
      }
    });
  }
  return false;
}
  
var customAddDiscountCode = (function() {
  var $body = $(document.body);
  $body.on('click', '.discount-add-code', function() {
    $('.go-cart__drawer').addClass('discount-modal-open');
  });
  $body.on('click', '.js-discount-modal-close', function() {
    $('.go-cart__drawer').removeClass('discount-modal-open');
  });
  $body.on('submit', '#discountForm', handlerCustomDiscountSubmit);
})();

/* TODO: see if we can find if a discount is applied without breaking the communication */
var customCartDiscount = (function (cart) {
  // check if any applied discount on checkout
  getCheckoutPage(null, function(checkoutPage){
    var totalDiscount = validateDiscount(checkoutPage);
    $('.discount-loading').slideUp('fast');
    if (totalDiscount && totalDiscount.amount) {
      var discount = parseFloat(totalDiscount.amount || 0);
      discount = discount.toFixed(2);
      discount = discount.replace('.00','');
      $('.discount-applied > .text-right > p').text('- $' + discount);
      $('.discount-applied').slideDown('fast');
      $('.discount-add__wrapper').css("display", "none");
    }
  })
})();



/*
 * Custom Search Popup on Mobile
 **/
$('body')
.on('click', '.js-open-SearchForm', function(e) { 
  e.preventDefault();

  var $this = $(this),
      $form = $this.parent().find('form');

  $form.addClass('is-active');
})
.on('click', function(e) { 
  if ( !$(e.target).closest('.mobile-nav--search').length ) { 
    $('.mobile-nav--search form').removeClass('is-active');
  }
})



var isEU = false;
var isChina = false;

function geoip(json) {
  if (json.continent_code == "EU") isEU = true;
  if (json.continent_code == "AS" && (json.country == "China" || json.country == "Hong Kong" )) isChina = true;
}

$(document).ready(function() {
  /* EU GEOLOCATION */
  $.get( "https://get.geojs.io/v1/ip/geo.js", function( data ) {
    eval(data);
  }).always( function() {
    if(isEU) {
      $('#footer-mc-embedded-subscribe-form .mce-subscribe-result').before('<div class="gdpr-check"><input type="checkbox" value="1" name="gdpr-check" /> I agree to the use of cookies and to the Privacy Policy.</div>');
      $('#newsletter-mc-embedded-subscribe-form #newsletter-mc-embedded-subscribe').before('<div class="gdpr-check"><input type="checkbox" value="1" name="gdpr-check" /> I agree to the use of cookies and to the Privacy Policy.</div>');
      $('#popup-mc-embedded-subscribe-form #popup-mc-embedded-subscribe').before('<div class="gdpr-check"><input type="checkbox" value="1" name="gdpr-check" /> I agree to the use of cookies and to the Privacy Policy.</div>');
      $('#create_customer .input-marketing').before('<div class="gdpr-check"><input type="checkbox" value="1" name="gdpr-check" /> I agree to the use of cookies and to the Privacy Policy.</div>');
      $('.form-questions-order.form-contact .notices').before('<div class="gdpr-check"><input type="checkbox" value="1" name="gdpr-check" /> I agree to the use of cookies and to the Privacy Policy.</div>');
    }
    if(isEU && !sessionStorage.getItem('showEUStorePopup')) {
      sessionStorage.setItem('showEUStorePopup',true);
      $('.store-popup#EUStorePopup').addClass('show');      
    }
    if (isChina && !sessionStorage.getItem('showChinaStorePopup')) {
      sessionStorage.setItem('showChinaStorePopup', true);
      $('.store-popup#ChinaStorePopup').addClass('show');
    }
  });
  
  var $registerForm = $('#create_customer');
  $registerForm.find('input[type="submit"]').bind('click', function (event) {
    if(isEU) {
      if (event) event.preventDefault();
      if ($(this).closest('form').find('input[name="gdpr-check"]').length) {
        if (!$(this).closest('form').find('input[name="gdpr-check"]').is(":checked")) {
          $(this).closest('form').find('.gdpr-check').addClass('error');
        } else {
          $(this).closest('form').find('.gdpr-check').removeClass('error');
          $registerForm.submit();
        }
      } else {
        $registerForm.submit();
      }
    }
  });
});
}